import { useAddToCart } from "@/hooks/user-hooks";
import { addProductToCart } from "@/redux/slices/cartSlice";
import { motion, AnimatePresence } from "framer-motion";
import { Loader2 } from "lucide-react";
import { useLocale } from "next-intl";
import { useDispatch } from "react-redux";

interface Props {
  showAvailability: boolean;
  data: {
    rent_type: string;
    available_dates?: string[];
    available_years?: number[];
  };
  changeTime: string[];
  setChangeTime: any;
  setShowAvailability: any;
  user?: any;
}

const AvailabilityModal: React.FC<Props> = ({
  showAvailability,
  data,
  changeTime,
  setChangeTime,
  setShowAvailability,
  user = null,
}: any) => {
  const locale = useLocale();

  const { mutate, isPending } = useAddToCart();
  const dispatch = useDispatch();

  const handleSelect = (value: string) => {
    if (changeTime.includes(value)) {
      setChangeTime(changeTime.filter((item: string) => item !== value));
    } else {
      setChangeTime([...changeTime, value]);
    }
  };

  const handleAddPropertyToCart = () => {
    if (!user) {
      const changProduct = {
        id: data?.id,
        title_en: data?.title_en,
        title_ar: data?.title_ar,
        description_en: data?.description_en,
        description_ar: data?.description_ar,
        thumbnail: data?.thumbnail,
        is_sale: data?.is_sale,
        changeTime,
      };

      dispatch(addProductToCart(changProduct));
      setShowAvailability(false);
      setChangeTime([]);
      return;
    }

    if (user) {
      const cartData = {
        property: data?.id,
        changeTime,
      };

      // setShowAvailability(false);
      mutate(cartData, {
        onSuccess: () => {
          setShowAvailability(false);
          setChangeTime([]);
        },
      });
    }
  };

  const isDaily = data?.rent_type === "daily";
  const items = isDaily
    ? data?.available_dates || []
    : data?.available_years?.map(String) || [];

  return (
    <AnimatePresence>
      {showAvailability && (
        <div>
          <motion.div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setShowAvailability(false)}
          ></motion.div>

          <motion.div
            className="bg-white rounded-2xl p-6 max-w-112.5 w-full shadow-xl fixed z-60 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.8, opacity: 0 }}
          >
            <h2 className="text-xl font-bold mb-4">
              {isDaily
                ? locale === "en"
                  ? "Select Days"
                  : "اختر الإيام"
                : locale === "en"
                  ? "Select Years"
                  : "اختر السنوات"}
            </h2>
            <div className="grid grid-cols-3 gap-3 max-h-60 overflow-y-auto">
              {items.map((item: string) => (
                <button
                  key={item}
                  onClick={() => handleSelect(item)}
                  className={`py-2 px-3 rounded-lg border transition-colors duration-200 cursor-pointer ${
                    changeTime.includes(item)
                      ? "bg-main text-white border-main"
                      : "bg-gray-100 text-gray-700 border-gray-300 hover:bg-gray-200"
                  }`}
                >
                  {isDaily ? new Date(item).toLocaleDateString() : item}
                </button>
              ))}
            </div>
            <div className="mt-4 flex justify-end gap-2">
              <button
                disabled={isPending}
                onClick={() => setChangeTime([])}
                className="py-2 px-4 rounded-lg bg-gray-300 hover:bg-gray-400 transition cursor-pointer disabled:cursor-not-allowed"
              >
                {locale === "en" ? "Clear" : "مسح"}
              </button>
              <button
                disabled={isPending || changeTime.length === 0}
                onClick={() => handleAddPropertyToCart()}
                className="py-2 px-4 rounded-lg bg-main text-white hover:bg-main/80 transition cursor-pointer disabled:cursor-not-allowed disabled:bg-gray-400"
              >
                {isPending ? (
                  <Loader2 className="animate-spin" />
                ) : locale === "en" ? (
                  "Confirm"
                ) : (
                  "تأكيد"
                )}
              </button>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default AvailabilityModal;
